import apiClient from './meta-client';
import type {
    CreateTemplatePayload,
    CreateTemplateResponse,
    MessengerTemplate,
    MessengerTemplateListResponse,
} from '@/types/messenger-template';

export const getMessengerTemplates = async (): Promise<MessengerTemplate[]> => {
    const response = await apiClient.get<MessengerTemplateListResponse>('/admin/meta/templates/');
    return response.data.data;
};

export const createMessengerTemplate = async (
    payload: CreateTemplatePayload
): Promise<CreateTemplateResponse> => {
    const response = await apiClient.post<CreateTemplateResponse>('/admin/meta/templates/', payload);
    return response.data;
};

export interface SimpleTemplatePayload {
    meta_app_id: number;
    template_name: string;
    language: string;
    category: string;
    image_url: string;
    body_text: string;
    button_text: string;
    button_url: string;
}

export const createSimpleTemplate = async (payload: SimpleTemplatePayload): Promise<MessengerTemplate> => {
    const response = await apiClient.post<{ message: string; data: MessengerTemplate }>(
        '/admin/meta/templates/simple',
        payload
    );
    return response.data.data;
};

export const submitMessengerTemplate = async (id: number): Promise<MessengerTemplate> => {
    const response = await apiClient.post<{ message: string; data: MessengerTemplate }>(
        `/admin/meta/templates/${id}/submit`
    );
    return response.data.data;
};

export const disableMessengerTemplate = async (id: number): Promise<MessengerTemplate> => {
    const response = await apiClient.post<{ message: string; data: MessengerTemplate }>(
        `/admin/meta/templates/${id}/disable`
    );
    return response.data.data;
};
